export function pathnameToTarget(pathname) {
  // eslint-disable-next-line no-unused-vars
  const [ignore, cohortId, deploymentId, ...rest] = pathname.split('/');
  const target = {
    cohortId,
    deploymentId,
  };

  const restWithoutPerformanceParams = removePerformanceParamsFromPathArray(rest);
  if (restWithoutPerformanceParams && restWithoutPerformanceParams.length > 0) {
    const ids = getTargetValues(restWithoutPerformanceParams);
    target.id = ids.pop();
    target.simplifiedAncestry = ids.reverse();
  }

  return target;
}

export function removePerformanceParamsFromPathArray(pathsArray) {
  const indexOfPerformanceParams = pathsArray.indexOf('e');
  const pathArrayWithoutPerformanceParams = indexOfPerformanceParams === -1 ? pathsArray : [
    ...pathsArray.slice(0, indexOfPerformanceParams),
    ...pathsArray.slice(indexOfPerformanceParams + 2),
  ];
  return pathArrayWithoutPerformanceParams;
}

export function targetToPathname(target) {
  const toURL = (...arr) => `/${arr.join('/')}`;

  if (!target.id) {
    return toURL(
      target.cohortId,
      target.deploymentId
    );
  }

  if (target.type === 'ACTIVITY' || !target.ancestry) {
    return toURL(
      target.cohortId,
      target.deploymentId,
      target.id
    );
  }

  const firstActivity = target.ancestry.find(({ elementType }) => elementType === 'ACTIVITY');
  const parent = target.ancestry.find(({ elementType }) => elementType !== 'PATHWAY');

  if (target.type === 'INTERACTIVE') {
    return toURL(
      target.cohortId,
      target.deploymentId,
      firstActivity.elementId,
      target.id
    );
  }

  if (parent.elementType === 'INTERACTIVE') {
    return toURL(
      target.cohortId,
      target.deploymentId,
      firstActivity.elementId,
      parent.elementId,
      target.id
    );
  }

  return toURL(
    target.cohortId,
    target.deploymentId,
    firstActivity.elementId,
    target.id
  );
}

export function generateSubTargetPart(subTarget) {
  if (!subTarget || Object.keys(subTarget).length === 0) {
    return '';
  }

  const stringify = (prop) => typeof prop === 'object'
    ? JSON.stringify(prop)
    : prop.toString();

  const searchPart = Object.entries(subTarget)
    .map(([key, value]) => `${key}/${encodeURIComponent(stringify(value))}`)
    .join('/');

  return `/${searchPart}`;
}

export function extractSubTarget(pathname) {
  if (!pathname || pathname.length === 0) {
    return undefined;
  }
  const split = getSubTargetValues(pathname.substring(1).split('/'));
  let names = split.filter((val, i) => !(i % 2));
  const values = split.filter((val, i) => i % 2);
  if (names.length > values.length) {
    // if url section doesn't take the expected format of /name/value ignore the last "name".
    names = names.slice(0, values.length);
  }
  return names.reduce((acc, val, i) => ({ ...acc, [val]: decodeURIComponent(values[i]) }), {});
}

export function getTargetValues(values) {
  const index = values.findIndex(isNotUUID);
  if (index === -1) {
    return values;
  }
  return values.slice(0, index);
}

export function getSubTargetValues(values) {
  const valuesWithPerformanceParams = removePerformanceParamsFromPathArray(values);
  const index = valuesWithPerformanceParams.findIndex(isNotUUID);
  if (index === -1) {
    return [];
  }
  return valuesWithPerformanceParams.slice(index);
}

export function getElementIdFromPathname(pathname) {
  if (!pathname) return null;
  const pathnameContainsElementId = containsElementId(pathname);
  if (pathnameContainsElementId) {
    const elementId = pathname.match(regexElementId) && pathname.match(regexElementId)[1];
    return elementId;
  }

  const target = pathnameToTarget(pathname);
  return target.id;
}

const regexUUID = new RegExp('^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$');
const regexContainsElementId = new RegExp('/e/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}');
export const regexElementId = new RegExp('/.*/e/([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})');
export const isNotUUID = (value) => !regexUUID.test(value);
export const containsElementId = (value) => regexContainsElementId.test(value);
